/** @jsx jsx */
import { jsx } from 'theme-ui';

import React from 'react';
import loadable from '@loadable/component';
import { usePlayerState, usePlayerSetUrl } from './PlayerContext';
import { Modal } from '../Modal';

const Player = loadable(() => import('./Player'));

const PlayerModal = () => {
	const setUrl = usePlayerSetUrl();
	const url = usePlayerState();

	if (!url) return <React.Fragment />;

	//const videoId = url.replace(/.*\//, '');
	return (
		<Modal onClose={() => setUrl(undefined)}>
			<div sx={{ variant: 'variants.containerBoxShadow', width: '90vw', mx:'auto', maxWidth:'1000px' }}>
				<Player url={url} />
			</div>
		</Modal>
	);
};

export default PlayerModal;
